<template>
  <div class="kabs-content-container">
    <div class="kabs-bg-image">
      <div class="md-layout md-alignment-center-center">
        <h1><slot name="section-title" /></h1>
      </div>
      <div class="kabs-content md-layout">
        <slot name="section-body" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: "KabContent"
}
</script>
<style lang="scss" scoped>
.kabs-content-container {
  width: 100%;
  min-height: 90vh;
  background-color: #f0f3f5;
  h1 {
    font-size: 66px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 36px;
  }

  .kabs-bg-image {
    background: url('../assets/scan-text-2@2x.png');
    background-position:cover;
    min-height: inherit;
  }
  .kabs-content {
    margin: auto 10% auto 14%;
  }
}

@media only screen and (max-width: 600px) {
  .kabs-content-container {
    h1 {
      font-size: 40px;
    }
  }
}

</style>